import {
  getDetail,
  deleteObj,
  getAll,
  getPage,
  addObj,
  modifyObj
} from '@/api/positioningdevicefittingstypeserv'

export default {
  state: {
    state_PositioningDeviceFittingsType_GetDetailResult: null,
    state_PositioningDeviceFittingsType_DeleteObjResult: null,
    state_PositioningDeviceFittingsType_GetAllResult: null,
    state_PositioningDeviceFittingsType_GetPageResult: null,
    state_PositioningDeviceFittingsType_AddObjResult: null,
    state_PositioningDeviceFittingsType_ModifyObjResult: null
  },
  mutations: {
    SET_POSITIONINGDEVICEFITTINGSTYPE_GETDETAIL_RESULT: (state, rst) => {
      state.state_PositioningDeviceFittingsType_GetDetailResult = rst
    },
    SET_POSITIONINGDEVICEFITTINGSTYPE_DELETEOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceFittingsType_DeleteObjResult = rst
    },
    SET_POSITIONINGDEVICEFITTINGSTYPE_GETALL_RESULT: (state, rst) => {
      state.state_PositioningDeviceFittingsType_GetAllResult = rst
    },
    SET_POSITIONINGDEVICEFITTINGSTYPE_GETPAGE_RESULT: (state, rst) => {
      state.state_PositioningDeviceFittingsType_GetPageResult = rst
    },
    SET_POSITIONINGDEVICEFITTINGSTYPE_ADDOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceFittingsType_AddObjResult = rst
    },
    SET_POSITIONINGDEVICEFITTINGSTYPE_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceFittingsType_ModifyObjResult = rst
    }
  },
  actions: {
    PositioningDeviceFittingsTypeServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTINGSTYPE_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTINGSTYPE_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingsTypeServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTINGSTYPE_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTINGSTYPE_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingsTypeServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTINGSTYPE_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTINGSTYPE_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingsTypeServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTINGSTYPE_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTINGSTYPE_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingsTypeServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTINGSTYPE_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTINGSTYPE_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingsTypeServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTINGSTYPE_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTINGSTYPE_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_PositioningDeviceFittingsType_GetDetailResult: state => {
      return state.state_PositioningDeviceFittingsType_GetDetailResult
    },
    get_PositioningDeviceFittingsType_DeleteObjResult: state => {
      return state.state_PositioningDeviceFittingsType_DeleteObjResult
    },
    get_PositioningDeviceFittingsType_GetAllResult: state => {
      return state.state_PositioningDeviceFittingsType_GetAllResult
    },
    get_PositioningDeviceFittingsType_GetPageResult: state => {
      return state.state_PositioningDeviceFittingsType_GetPageResult
    },
    get_PositioningDeviceFittingsType_AddObjResult: state => {
      return state.state_PositioningDeviceFittingsType_AddObjResult
    },
    get_PositioningDeviceFittingsType_ModifyObjResult: state => {
      return state.state_PositioningDeviceFittingsType_ModifyObjResult
    }
  }
}
